import { useEffect, useState } from 'react';
import { PluginConfig } from '../models/plugin-config';

export type Labels = {
  [key: string]: string;
}

export function useLabels(config: PluginConfig | null) {
  const [labels, setLabels] = useState<Labels | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!config) return;
    setIsLoading(true);
    const url = `${import.meta.env.VITE_BE_API_DOMAIN}chains/translations/${config.chainId}/${config.language}/clubtranslations`;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch labels');
        return res.json();
      })
      .then(setLabels)
      .catch((e) => setError(e.message))
      .finally(() => setIsLoading(false));
  }, [config]);

  return { labels, isLoading, error };
}
